import clsx from "clsx";
import {Textarea as UITextarea, type TextareaProps} from "@headlessui/react";

export const Textarea: React.FC<TextareaProps> = ({className, ...props}) => {
  return (
    <UITextarea
      as="textarea"
      {...props}
      className={clsx(
        "w-full px-4 py-2 border rounded-md border-gray-300 focus:outline-none focus:border-black",
        className,
      )}
    />
  );
};
